<template>
  <div id="chat-question">
    <div class="pc">
      <div class="header">
        <div class="box">
          <i class="el-icon-upload2 btn-export">导出</i>
        </div>
      </div>
      <div class="main">
        <div class="question">
          <div class="h3">
            <span>Tape问题汇总</span>
            <img class="logo" src="@/assets/logo.png" />
          </div>
          <div class="desc">{{questions.length}}条问题 2020年06月16日</div>
          <div class="box">
            <div class="item" v-for="d in questions" :key="d.id">{{d.desc}}</div>
          </div>
        </div>
        <span class="copyright">版权所有 © SENKOO. All rights reserved. 沪ICP备18042729号-1</span>
      </div>
    </div>
    <div class="mobile">
      <Nav class="header">
        <i class="el-icon-arrow-left btn" slot="prefix" @click="$router.back()"></i>
        Tape问题汇总
        <i slot="suffix" class="el-icon-share btn" @click="toShare"></i>
      </Nav>
      <div class="question">
        <div class="desc">
          <span>{{questions.length}}条问题</span>
          <span>2020年06月16日</span>
        </div>
        <div class="box">
          <div class="item" v-for="d in questions" :key="d.id">{{d.desc}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from "@/components/Nav";
export default {
  components: { Nav },
  data() {
    return {
      questions: [
        { id: 1, desc: "1、 187店铺，1752点位客户提供尺寸与测量不符" },
        { id: 2, desc: "1、 187店铺，1752点位客户提供尺寸与测量不符" },
        { id: 3, desc: "1、 187店铺，1752点位客户提供尺寸与测量不符" },
        { id: 4, desc: "1、 187店铺，1752点位客户提供尺寸与测量不符" },
        { id: 5, desc: "1、 187店铺，1752点位客户提供尺寸与测量不符" },
        { id: 6, desc: "1、 187店铺，1752点位客户提供尺寸与测量不符" },
        { id: 7, desc: "1、 187店铺，1752点位客户提供尺寸与测量不符" },
        { id: 8, desc: "1、 187店铺，1752点位客户提供尺寸与测量不符" },
        { id: 9, desc: "1、 187店铺，1752点位客户提供尺寸与测量不符" }
      ]
    };
  },
  methods: {
    toShare() {
      console.log("to share:");
      window.print();
    }
  }
};
</script>
<style lang="scss" scoped>
#chat-question {
  display: flex;
  flex-direction: column;
  .pc {
    display: block;
    .header {
      height: 80px;
      line-height: 80px;
      background: hsla(0, 0%, 100%, 1);
      // border: 1px dashed red;
      .box {
        width: 1000px;
        margin: 0 auto;
        // border: 1px dashed red;
        text-align: right;
        .btn-export {
          color: hsla(0, 0%, 20%, 1);
          font-size: 16px;
          cursor: pointer;
        }
        .btn-export:hover {
          color: hsla(180, 64%, 42%, 1);
        }
      }
    }
    .main {
      height: calc(100vh - 80px);
      position: relative;
      background: hsla(0, 0%, 96%, 1);
      .question {
        width: 1000px;
        height: 780px;
        margin: 30px auto 0;
        display: flex;
        flex-direction: column;
        background: hsla(0, 0%, 100%, 1);
        // border: 1px dashed red;
        .h3 {
          height: 90px;
          margin: 0 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: hsla(0, 0%, 20%, 1);
          font-size: 18px;
          border-bottom: 1px solid hsla(0, 0%, 90%, 1);
          .logo {
            width: 80px;
            height: 30px;
          }
        }
        .desc {
          margin: 30px 30px 15px;
          text-align: right;
          font-size: 12px;
          color: hsla(0, 0%, 60%, 1);
        }
        .box {
          flex: 1;
          overflow-y: auto;
          // border: 1px dashed red;
          .item {
            margin: 0 30px;
            height: 70px;
            display: flex;
            align-items: center;
            color: hsla(0, 0%, 20%, 1);
            font-size: 14px;
            border-bottom: 1px solid hsla(0, 0%, 90%, 1);
          }
        }
      }

      .copyright {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 14px;
        color: hsla(0, 0%, 60%, 1);
      }
    }
  }
  .mobile {
    display: none;
  }
}
@media screen and (max-width: 750px) {
  #chat-question {
    .pc {
      display: none;
    }
    .mobile {
      display: block;
      .question {
        .desc {
          height: 60px;
          width: 100%;
          padding: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 13px;
          color: hsla(0, 0%, 60%, 1);
          background: hsla(0, 0%, 95%, 1);
        }
        .box {
          padding: 0 15px;
          .item {
            padding: 15px 0;
            border-bottom: 1px solid hsla(0, 0%, 86%, 1);
            font-size: 14px;
            line-height: 1.45;
            color: hsla(0, 0%, 20%, 1);
          }
        }
      }
    }
  }
}
@media print {
  .header {
    display: none;
  }
}
</style>